<template>
  <div style="margin-top: 30px; padding:11px;">
    <h2 class="text-center fw-bold mb-3"> Sözleşme Tarihi Bitenler</h2>
    <button @click="exportToExcel" class="btn btn-success mb-3">Excel'e Aktar</button>
    <div class="table-responsive">
      <table class="table table-bordered align-middle">
        <thead>
        <tr>
          <th>No</th>
          <th>Firma Adı</th>
          <th>Sözleşme No</th>
          <th>Sözleşme Adı</th>
          <th>Başlangıç Tarihi</th>
          <th>Bitiş Tarihi</th>
          <th>Sözleşme Tutarı</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(contract, index) in sortedContracts" :key="index">
          <td>{{ index + 1 }}</td>
          <td>{{ contract.companyname }}</td>
          <td>{{ contract.contractnumber }}</td>
          <td>{{ contract.contractname }}</td>
          <td>{{ formatDate(contract.contractdate) }}</td>
          <td> {{ formatDate(contract.renewalcontractdate) }}</td>
          <td>{{ formatCurrency(contract.contractprice) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import * as XLSX from "xlsx";

export default {
  name: "PassiveContractPage",
  data() {
    return {
      inActiveContractData: [],
    }
  },
  computed: {
    sortedContracts() {
      return [...this.inActiveContractData].sort((a, b) => {
        const dateA = new Date(a.renewalcontractdate);
        const dateB = new Date(b.renewalcontractdate);
        return dateA - dateB; // Küçükten büyüğe sıralama
      });
    }
  },
  created() {
    this.getInactiveContractData();
  },
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return "-";
      return new Date(timestamp).toLocaleDateString("tr-TR");
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("tr-TR", {
        style: "currency",
        currency: "TRY"
      }).format(value);
    },
    getInactiveContractData() {
      apiClient.get("contract/inActiveContract").then(res => {
        this.inActiveContractData = res.data;
      }).catch(error => {
        console.error("Veri çekme hatası:", error);
      });
    },
    exportToExcel() {
      const data = this.sortedContracts.map((contract, index) => ({
        "No": index + 1,
        "Firma Adı": contract.companyname,
        "Sözleşme No": contract.contractnumber,
        "Sözleşme Adı": contract.contractname,
        "Başlangıç Tarihi": this.formatDate(contract.contractdate),
        "Bitiş Tarihi": this.formatDate(contract.renewalcontractdate),
        "Sözleşme Tutarı": this.formatCurrency(contract.contractprice)
      }));

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Biten Sözleşmeler");

      XLSX.writeFile(wb, "biten_sozlesmeler.xlsx");
    }
  },
}
</script>

<style scoped>
th, td {
  text-align: center;
  vertical-align: middle;
}

h2 {
  font-size: 24px;
  color: #333;
  text-transform: uppercase;
}

button {
  display: block;
  margin: 0 auto 20px;
  padding: 10px 15px;
  font-size: 16px;
}
</style>
